import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface ParkingTypesState {
  data: [] | null | any;
  totalPage: number | null;
  currentPage: number | null;
  totalRecords: number | null;
}

const initialState: ParkingTypesState = {
  data: null,
  totalPage: null,
  currentPage: null,
  totalRecords: null,
};

export const parkingTypesSlice = createSlice({
  name: 'parkingTypes',
  initialState,
  reducers: {
    setParkingType: (state, action) => {
      state.data = action.payload.data;
      state.totalPage = action.payload.totalPage;
      state.currentPage = action.payload.currentPage;
      state.totalRecords = action.payload.totalRecords;
    },
    addNewParkingType: (state: any, action) => {
      state.data = [action.payload.data, ...state.data];
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setParkingType, addNewParkingType, reset } = parkingTypesSlice.actions;
export const getparkingType = (state: RootState) => state.parkingTypes.data;
export const getParkingTypeTotalRecords = (state: RootState) => state.parkingTypes.totalRecords;

export default parkingTypesSlice.reducer;
